import type { ComputedRef } from 'vue'
import { ExperimentCookieName, ExperimentName } from '../types'
import { computed, useExperimentAssignment } from '#imports'

/** The signup experiment version this visitor is counted in, or null when the experiment is off or they aren't in it. */
export const useSignupVersion = (): ComputedRef<string | null> => {
    const assignment = useExperimentAssignment({ cookieName: ExperimentCookieName.SIGNUP, experimentName: ExperimentName.SIGNUP })

    return computed(() => assignment.value?.version ?? null)
}
